import { useEffect, useState } from 'react'
import { DUE_DATE_HIGHLIGHT_WINDOW_MS, MAX_TIMEOUT_MS, shouldHighlightDueDate } from '../utils/due-date'

/**
 * Whether a due date is close enough to read as urgent, re-evaluated when the
 * reminder crosses into the window — a row sitting on screen has to start
 * highlighting on its own, without waiting for an unrelated re-render.
 */
export function useDueSoon(scheduledAt: Date | undefined): boolean {
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    if (!scheduledAt) return

    const msUntilHighlight = scheduledAt.getTime() - Date.now() - DUE_DATE_HIGHLIGHT_WINDOW_MS
    if (msUntilHighlight <= 0) return

    // Re-arms itself through `refreshKey` for dates further out than a timer
    // can reach.
    const timer = setTimeout(() => setRefreshKey((key) => key + 1), Math.min(msUntilHighlight, MAX_TIMEOUT_MS))

    return () => clearTimeout(timer)
  }, [refreshKey, scheduledAt])

  return scheduledAt ? shouldHighlightDueDate(scheduledAt) : false
}
